export default "__VITE_ASSET__Byr58utC__"